const tabs = document.querySelectorAll('[data-tabs]');
const CLASSES = {
  active: 'is-active',
};

const initSimpleTabs = () => {
  tabs.forEach((item) => {
    const $tabCaptions = item.querySelector('[data-tabs-captions]');
    const $tabBlocks = item.querySelector('[data-tabs-blocks]');

    if (!$tabCaptions || !$tabBlocks) {
      return;
    }

    const $tabCaptionElements = $tabCaptions.children;
    const $tabBlocksElements = $tabBlocks.children;

    for (let i = 0; i < $tabCaptionElements.length; i++) {
      const caption = $tabCaptionElements[i];

      caption.addEventListener('click', () => {
        resetAll($tabCaptionElements, $tabBlocksElements);
        setActive($tabCaptionElements, i);
        setActive($tabBlocksElements, i);
      });
    }
  });
};

const setActive = (elements, index) => {
  if (elements[index]) {
    elements[index].classList.add(CLASSES.active);
  }
};

const resetAll = (tabsList, blocksList) => {
  for (let i = 0; i < tabsList.length; i++) {
    tabsList[i].classList.remove(CLASSES.active);
  }

  for (let i = 0; i < blocksList.length; i++) {
    blocksList[i].classList.remove(CLASSES.active);
  }
};

export {initSimpleTabs};
